import PropTypes from 'prop-types';
import React from 'react';

import CmsBlock from 'Component/CmsBlock';
import Loader from 'Component/Loader';
import MyAccountDocumentsForm from 'Component/MyAccountDocumentsForm';
import MyAccountStatusMessage from 'Component/MyAccountStatusMessage';
import {
    CANCELED_STATUSES,
    GROUP_ID_EMPLOYEE,
    GROUP_ID_PRO,
    GROUP_ID_STUDENT, PENDING_STATUSES,
    STATUS_ATTENTE_ETUDIANT,
    STATUS_ATTENTE_ETUDIANT_NO_DOC, STATUS_DESACTIVE_ETUDIANT, STATUS_REFUSE_ETUDIANT
} from 'Route/MyAccount/MyAccount.config';
import {
    MyAccountInformation as SourceMyAccountInformation
} from 'SourceComponent/MyAccountInformation/MyAccountInformation.component';

import './MyAccountDocuments.style';

/** @namespace PeggysagePwa/Component/MyAccountDocuments/Component */
export class MyAccountDocumentsComponent extends SourceMyAccountInformation {
    static propTypes = {
        ...SourceMyAccountInformation.propTypes,
        isMobile: PropTypes.bool.isRequired,
        onChangeFile: PropTypes.func.isRequired
    };

    renderIntroduction() {
        const {
            customer: {
                group_id: customerGroupId = 0,
                status_pro: accountStatus
            }
        } = this.props;

        if (!([GROUP_ID_PRO, GROUP_ID_STUDENT, GROUP_ID_EMPLOYEE].includes(customerGroupId)
            || PENDING_STATUSES.includes(accountStatus)
            || CANCELED_STATUSES.includes(accountStatus))) {
            return null;
        }

        const isStudent = customerGroupId === GROUP_ID_STUDENT
            || [
                STATUS_ATTENTE_ETUDIANT,
                STATUS_ATTENTE_ETUDIANT_NO_DOC,
                STATUS_REFUSE_ETUDIANT,
                STATUS_DESACTIVE_ETUDIANT
            ].includes(accountStatus);

        const text = isStudent
            ? __('Mettez à jour vos documents ou envoyez les documents manquants à la validation de votre compte étudiant.')
            : __('Mettez à jour vos documents ou envoyez les documents manquants à la validation de votre compte Pro.');

        return (
            <div block="MyAccountDocuments" elem="Introduction">
                <p>{ text }</p>
            </div>
        );
    }

    renderAccountStatus() {
        const { isMobile } = this.props;

        if (isMobile) {
            return null;
        }

        return <MyAccountStatusMessage />;
    }

    renderFilesForm() {
        const {
            customer,
            onCustomerSave,
            onChangeFile
        } = this.props;

        return (
            <MyAccountDocumentsForm
              customer={ customer }
              onSave={ onCustomerSave }
              onChangeFile={ onChangeFile }
            />
        );
    }

    renderHelpMessage() {
        return (
            <div block="MyAccountDocuments" elem="HelpMessage">
                <CmsBlock identifier="account_my_documents_help" />
            </div>
        );
    }

    render() {
        const { isLoading } = this.props;

        return (
            <div
              block="MyAccountDocuments"
              elem="Wrapper"
            >
                <Loader isLoading={ isLoading } />
                { this.renderAccountStatus() }
                { this.renderIntroduction() }
                { this.renderFilesForm() }
                { this.renderHelpMessage() }
            </div>
        );
    }
}

export default MyAccountDocumentsComponent;
